import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ScrollUpButton = () => {
  const [visible, setVisible] = useState(false);
  const [hovering, setHovering] = useState(false);
  
  const [isScrollingDown, setIsScrollingDown] = useState(false); // Track if user is scrolling down
  const [lastScrollY, setLastScrollY] = useState(0); // Track the last scroll position

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 1.2);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > lastScrollY) {
      setIsScrollingDown(true); // Scrolling down
    } else {
      setIsScrollingDown(false); // Scrolling up
    }
    setLastScrollY(currentScrollY);
  };

  // Set up the scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]); // Re-run the effect if lastScrollY changes

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const location = useLocation();
  if (location.pathname.startsWith("/infoplace")) return <></>;
  return (
    <div style={styles.wrapper}>
      <div
        style={{ ...styles.upIconContainer }}
        onMouseOver={(e) => setHovering(true)}
        onMouseOut={(e) => setHovering(false)}
        onClick={(e) => {
          setHovering(false);
          if (visible) scrollToTop();
        }}
      >
        <img
          src={"/assets/icons/up-a.svg"}
          style={{
            ...styles.upIcon,
            opacity: hovering || !visible || isScrollingDown ? "0" : "1",
          }}
          alt="вгору"
        />
        <img
          src={"/assets/icons/up-a.svg"}
          style={{
            ...styles.upIcon,
            opacity: !hovering || !visible || isScrollingDown ? "0" : "1",
          }}
          alt="вгору"
        />
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  wrapper: {},
  upIconContainer: {
    position: "fixed",
    left: "100%",
    bottom: "0%",
    width: "min(5rem, 15vw)",
    height: "min(5rem, 15vw)",
    transform: "translate(-150%, -50%)",
    cursor: "pointer",
    zIndex: "10000",
  },
  upIcon: {
    transition: "all 0.3s ease",
    position: "absolute",
  },
};

export default ScrollUpButton;
